import React from 'react';
import { Flex, Input } from 'antd';
import { CheckOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import { CityRowProps } from './CityRow';

export interface CountryRowProps {
  city: any;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}


const CountryRow: React.FC<CountryRowProps> = ({
                                              city,
                                              isEditing,
                                              onEdit,
                                              onSave,
                                              onCancel,
                                              inputValue,
                                              setInputValue,
                                            }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isEditing ? (
        <>
          <Input
            allowClear
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            style={{ marginRight: 8 }}
          />
          <CheckOutlined
            onClick={onSave}
            style={{ marginLeft: 8, cursor: 'pointer', color: 'green' }}
          />
          <CloseOutlined
            onClick={onCancel}
            style={{ marginLeft: 8, cursor: 'pointer', color: 'red' }}
          />
        </>
      ) : (
        <Flex justify={'space-between'} style={{ width: '100%' }}>
          <div>
            {city.title}
          </div>
          <div>
            <EditOutlined
              onClick={onEdit}
              style={{ marginLeft: 8, cursor: 'pointer' }}
            />
          </div>

        </Flex>
      )}
    </div>
  );
};

export default CountryRow;